/* globals Stripe */
'use strict';

import $ from 'jquery';
import StripeForm from '@/js/modules/stripe_form';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function initStripeAchForm($form) {
    if (!$form.length || $form.data('paymentInitialized')) {
      return;
    }
    $form.data('paymentInitialized', true);

    const stripe = new Stripe($('#stripe_public_key').val(), {
      stripeAccount: $('#stripe_connect_id').val(),
    });

    let elements;

    const kind = $form.find('#kind').val();
    const id = $form.find('#id').val();

    const $button = $form.find('button');

    const paymentIntentUrl = `/client_payments/${kind}/${id}/xhr_generate_stripe_ach_payment_intent`;
    initializePaymentElement(paymentIntentUrl);

    // Fetches a payment intent and captures the client secret
    async function initializePaymentElement(paymentIntentUrl) {
      // create payment intent and fetch client secret
      const response = await fetch(paymentIntentUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shareable_uuid: $form.find('#shareable_uuid').val(),
        }),
      });

      const res = await response.json();
      const clientSecret = res.client_secret;

      // initialize elements for payment intent
      elements = stripe.elements({
        theme: 'stripe',
        clientSecret,
      });

      // create and mount payment element
      const paymentElement = elements.create('payment', { layout: 'accordion' });
      paymentElement.mount('.stripe-payment-element');

      // TODO: switch to https://stripe.com/docs/js/element/events/on_ready
      // show submit button once Payment Element is ready
      setTimeout(() => {
        $button.css('display', 'inline-flex');
      }, 2000);
    }

    $form[0].addEventListener('submit', handleSubmit);
    async function handleSubmit(e) {
      e.preventDefault();

      $button.addClass('button-loading').prop('disabled', true);
      const res = await stripe.confirmPayment({
        elements,
        redirect: 'if_required',
      });

      if (res.error) {
        $button.removeClass('button-loading').prop('disabled', false);

        // validation errors are shown on the payment element
        if (res.error.type !== 'validation_error') {
          alert(`An error occured: ${res.error.message}`);
        }
      } else {
        // TODO: review and optimize
        const formData = $form.serializeArray();
        formData.push({ name: 'payment_intent_id', value: res.paymentIntent.id });
        formData.push({ name: 'payment_method', value: 'bank_transfer' });
        if ($form.find('.field--stripe-form-guest-email').length > 0) {
          formData.push({ guest_email: $form.find('.field--stripe-form-guest-email').val() });
        }

        const processPaymentURL = `/client_payments/${kind}/${id}/xhr_process_stripe_ach_payment`;

        // at this point, payment on Stripe is completed,
        // but there's something wrong with `xhr_process_stripe_ach_payment`
        // so we just alert clients & keep the submit button disabled
        const alertProcessingFailed = () =>
          alert(
            'Your payment might be completed, but there was something wrong with processing it. Please do not pay again and contact Customer Support.'
          );

        $.post(processPaymentURL, $.param(formData), function (data) {
          if (data.success) {
            window.location.reload();
          } else {
            alertProcessingFailed();
          }
        }).fail(alertProcessingFailed);
      }
    }
  }

  function initCardPaymentForm($form) {
    if (!$form.length || $form.data('paymentInitialized')) {
      return;
    }
    $form.data('paymentInitialized', true);

    const stripeForm = new StripeForm($('#stripe_connect_id').val());

    function submitStripeForm(clientSecret) {
      const $button = $form.find('button');

      stripeForm.submitWithPaymentIntent(clientSecret).then((result) => {
        if (result.error) {
          $button.removeClass('button-loading').prop('disabled', false);
          alert(`An error occured: ${result.error.message}`);
        } else {
          const kind = $form.find('#kind').val();
          const id = $form.find('#id').val();
          const formData = $form.serializeArray();
          formData.push({ name: 'payment_intent_id', value: result.paymentIntent.id });
          formData.push({ name: 'payment_method', value: 'credit_card' });
          if ($form.find('.field--stripe-form-guest-email').length > 0) {
            formData.push({ guest_email: $form.find('.field--stripe-form-guest-email').val() });
          }

          const processPaymentURL = `/client_payments/${kind}/${id}/xhr_process_payment`;
          // at this point, payment on Stripe is completed, but there's something wrong with `xhr_process_payment`
          // so we just alert clients & keep the submit button disabled
          const alertProcessingFailed = () =>
            alert(
              'Your payment might be completed. But there was something wrong with the system. Please contact your designer about the issues.'
            );

          $.post(processPaymentURL, $.param(formData), function (data) {
            if (data.success) {
              window.location.reload();
            } else {
              alertProcessingFailed();
            }
          }).fail(alertProcessingFailed);
        }
      });
    }

    $form.on('submit', (e) => {
      e.preventDefault();
      const $button = $form.find('button');
      const kind = $form.find('#kind').val();
      const id = $form.find('#id').val();

      $button.addClass('button-loading').prop('disabled', true);
      const postData = {};

      if ($form.find('#shareable_uuid').val().length > 0) {
        postData['shareable_uuid'] = $form.find('#shareable_uuid').val();
      }
      if ($form.find('.field--stripe-form-guest-email').length > 0) {
        postData['guest_email'] = $form.find('.field--stripe-form-guest-email').val();
      }

      $.post(
        `/client_payments/${kind}/${id}/xhr_generate_payment_intent`,
        postData,
        function (data) {
          if (data.success) {
            submitStripeForm(data.client_secret);
          } else {
            alert(`An error occured: ${data.error_message}`);
            $button.removeClass('button-loading').prop('disabled', false);
          }
        }
      );
    });

    $form.on('click', '.client-pay-form__note-toggle-link', () => {
      $form.find('.client-pay-form__client-note').show();
      $form.find('textarea[name="invoice[client_note]"]').focus();

      $form.find('.client-pay-form__note-toggle-link').remove();

      return false;
    });
  }

  $(document).on($.modal.OPEN, '.modal--client-pay-stripe-ach', (e) => {
    initStripeAchForm($(e.target).find('.client-pay-stripe-ach'));
  });

  $(document).on($.modal.OPEN, '.modal--client-pay', (e) => {
    initCardPaymentForm($(e.target).find('.client-pay-form'));
  });

  $(document).on($.modal.OPEN, '.modal--client-checkout', (e) => {
    const $modal = $(e.target);

    // Stripe's Payment Element cannot measure itself inside a hidden tab panel,
    // so each form is set up when its tab becomes visible
    function initVisibleForms() {
      initCardPaymentForm($modal.find('.client-pay-form:visible'));
      initStripeAchForm($modal.find('.client-pay-stripe-ach:visible'));
    }

    $modal[0].addEventListener('ui--tabs:shown', initVisibleForms);
    initVisibleForms();
  });

  $(document).on($.modal.CLOSE, '.modal--client-pay', () => {
    $('.modal--client-pay').remove();
  });

  $(document).on($.modal.CLOSE, '.modal--client-pay-stripe-ach', () => {
    $('.modal--client-pay-stripe-ach').remove();
  });

  $(document).on($.modal.CLOSE, '.modal--client-checkout', () => {
    $('.modal--client-checkout').remove();
  });
});
